import BackendService from './BackendService';
import { STORAGE_KEYS } from '../const';
import CacheHelper from '../helpers/CacheHelper';

const cache = {};

async function getGstPreference() {
  const resp = await BackendService.get('/settings/gst_preference/');
  return resp.gst_preference;
}
async function updateGstPreference(data) {
  return BackendService.post('/settings/gst_preference/', data);
}
async function getShopSettings() {
  return BackendService.get('/shop_profile/');
}
async function updateShopSettings(data = {}) {
  return BackendService.post('/shop_profile/', data);
}
async function getGeKartKey() {
  return BackendService.get('/settings/gekart_sync/key/');
}
async function updateGeKartKey(data) {
  return BackendService.post('/settings/gekart_sync/key/', data);
}
async function getExternalTokenKey() {
  return BackendService.get('/settings/external_token/');
}
async function resetExternalTokenKey() {
  return BackendService.put('/settings/external_token/');
}
async function updateBillPrinterIP(data) {
  return BackendService.post('/settings/bill_printer_ip/', data);
}
async function updatePointsToRupee(data) {
  return BackendService.post('/settings/reward_points/', data);
}
async function getSubscriptionPlans() {
  return BackendService.get('/subscriptions/');
}
async function initiatePayment(data) {
  return BackendService.post('/subscriptions/payments/', data);
}
async function loadShopProfile(shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID)) {
  if (!shopId) return;

  const cacheKey = `shop-${shopId}-shop-profile`;
  const cachedShopProfile = CacheHelper.get(cache, cacheKey);
  if (cachedShopProfile) {
    return cachedShopProfile;
  }

  const shopProfile = await BackendService.get(`/organizations/${shopId}`, { requireOrg: false });
  CacheHelper.store(cache, cacheKey, shopProfile);
  return shopProfile;
}
async function getUnappliedSubscription() {
  return BackendService.get('/subscriptions/payments/unused/');
}
async function activatePlan(data = {}) {
  return BackendService.post('/subscriptions/payments/activate/', data);
}
async function getPaymentModes(params) {
  return BackendService.get('/payment-modes/', { params });
}
async function updatePaymentModes(id, data) {
  return BackendService.patch(`/payment-modes/${id}/`, data);
}
async function createPaymentMode(data) {
  return BackendService.post('/payment-modes/', data);
}
async function uploadShopLogo(data) {
  return BackendService.post(`/shops/settings/logo/`, data);
}
async function attachQuickbookAccount(data) {
  return BackendService.post('/shops/settings/quickbook/attach/', data);
}
async function detachQuickbookAccount() {
  return BackendService.destroy('/shops/settings/quickbook/detach/');
}
async function fetchQuickbookProducts() {
  return BackendService.get('/quickbooks/products/fetch/');
}
async function getExternalSyncFailedSales() {
  return BackendService.get('/external-sales-sync/failed-logs/');
}
async function syncAllExternalSales() {
  return BackendService.get('/external-sales-sync/sync/');
}
async function syncExternalSale(id) {
  return BackendService.get(`/external-sales-sync/sync/${id}/`);
}

const ShopSettingsService = {
  getGeKartKey,
  updateGeKartKey,
  getGstPreference,
  updateGstPreference,
  getExternalTokenKey,
  resetExternalTokenKey,
  updateBillPrinterIP,
  updatePointsToRupee,
  getSubscriptionPlans,
  initiatePayment,
  loadShopProfile,
  getUnappliedSubscription,
  activatePlan,
  getShopSettings,
  updateShopSettings,
  getPaymentModes,
  updatePaymentModes,
  createPaymentMode,
  uploadShopLogo,
  attachQuickbookAccount,
  detachQuickbookAccount,
  fetchQuickbookProducts,
  getExternalSyncFailedSales,
  syncAllExternalSales,
  syncExternalSale,
};

export default ShopSettingsService;
